import script from "./QModalEditPass.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalEditPass.vue?vue&type=script&setup=true&lang=js"

import "./QModalEditPass.vue?vue&type=style&index=0&id=15dfc097&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15dfc097"]])

export default __exports__